/**
 * Ticket workflow statuses that mean "done" — no agent wake / reopen.
 * Keep in sync with functions/lib/ticketStatus.js (Cloud Functions SoT).
 */

const TERMINAL_TICKET_STATUSES = new Set(['resolved', 'closed']);

/**
 * @param {unknown} status
 * @returns {boolean}
 */
export function isTerminalTicketStatus(status) {
  return typeof status === 'string' && TERMINAL_TICKET_STATUSES.has(status.trim());
}

export { TERMINAL_TICKET_STATUSES };
